

const TickUserIcon = () => {
    return (
        <svg
            style={{
                transform: "translate(1px, 0)"
            }}
            className={"svg-icon"}
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M19.3407 11.4277L13.4549 19.2849L9.52637 16.342" stroke="#0F1110" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M7.19768 7.14244C8.97289 7.14244 10.412 5.70335 10.412 3.92815C10.412 2.15295 8.97289 0.713867 7.19768 0.713867C5.42248 0.713867 3.9834 2.15295 3.9834 3.92815C3.9834 5.70335 5.42248 7.14244 7.19768 7.14244Z"
                stroke="#0F1110" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M4.34047 17.8568H0.769043V15.7139C0.770161 14.4433 1.1478 13.2015 1.85425 12.1454C2.56071 11.0892 3.5643 10.2661 4.73827 9.78005C5.91224 9.29395 7.20393 9.16665 8.45021 9.41423C9.69649 9.66181 10.8414 10.2732 11.7405 11.1711"
                stroke="#0F1110" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default TickUserIcon

